export const AUTH_VALID_EMAIL = "ironmountain";

export const ACTIVITY_TS = "activityTS";
export const IN_TS = "inLocalTS";
export const APPROVED = "approved";
export const DELETED = "deleted";
export const EMAIL = "email";
export const EQUALS = "==";
export const NOT_EQUALS = "!=";
export const IN = "in";
export const IS_MANAGER = "isManager";
export const IS_APPROVER = "isApprover";
export const IS_DELETED = "isDeleted";
export const MANAGER_ID = "managerId";
export const WORKER_ID = "workerId";
export const STATUS = "status";
export const NEW = "new";
export const WORKER_TYPE = "workerType";
export const ARRAY_LIMIT = 9;
export const workerHistory = "workerHistory";
export const punchHistory = "punchHistory";
export const BUILDINGS = "buildings";
export const BUILDINGS_SUBCOLLECTION = "buildings";
export const LOCATIONS_COLLECTION = "locations";
export const IMWAREHOUSEMETRICS_COLLECTION = "imWarehouseMetrics";
export const DASHBOARD_COLLECTION = "dashboard";
export const DSC_DASHBOARD_COLLECTION = "dscDashboard";
export const CAPACITY_PLANNING="capacityPlanning";
export const COUNTRY = "country";
export const MY_TEAM = "myTeam";
export const OTHER_TEAM = "otherTeam";
export const FIRST_NAME = "firstName";
export const LAST_NAME = "lastName";
export const CWK_ID_LENGTH = 7;
export const KILL_CWK_AUTO = false;
export const REFRESH_INTERVAL = 900000;
export const KILL_UPLOAD_CWK = false;
export const WORKER_ROLES = "workerRoles";
export const WORKER_ROLES_HISTORY = "workerRolesHistory";
export const COUNTRY_NAME = "countryName";
export const IMT_ACTIVITY_GROUP = "imtActivityGroup";
export const IMT_ACTIVITY_GROUPHISTORY = "imtActivityGroupHistory";
export const COUNTRIES = "countriesDev";
export const INCOMPLETE_NUM_OF_DAYS = 30;
export const LAST = "last";
export const TRIPDELETED = "tripDeleted";
export const IMW_PROJECTS = "imWarehouseProjects";
export const SORTSCAN ="sortScan";
// Review page constants
export const STATUS_IN = "IN";
export const STATUS_OUT = "OUT";
export const STATUS_TRANSFER = "TRANSFER";
export const STATUS_DELETED = "deleted";
export const TEMP = "temp";
export const EMPLOYEE = "employee";
export const ARCHIVE = "archive";
export const KEY_DATE_FORMAT = "DDMMMYYYY";

// Report constants
export const ACTIVITY_GROUPS = [
  "Transactional",
  "Non-Transactional",
  "Project",
];

export const ACTIVITY_GROUPS2 = [
  "Transactional",
  "Non-Transactional",
  "Project",
  "Building Moves",
];
export const TOTAL = "Total";
export const CUSTOMER_SITE = "Customer Site";
export const PENDING = "Pending";
export const PENDING_I18N = "pgReview.tableStaticText.pending";
export const SPACE = " ";
export const REMOTE = "Remote";
export const COUNTRYCODE = "countryCode";
export const TESTCOUNTRY = "testCountry";
export const DOT = ".";

// Remote config specific
export const CONFIG_COLLECTION = "config";
export const CONFIG_IM_TIME = "imTime";
export const CONFIG_WORKDAY = "workdayConfig";

//Changes for delegating manager full feature
export const MANAGE_FOR_BY_COUNTRY = false;
export const MANAGE_FOR_BY_COUNTRY_FOR_REVIEW_VIEW = true;

//worker schedule related
export const workersSchedule = "workersSchedule";
export const workersScheduleHistory = "workersScheduleHistory";

export const GREATER_THAN_OR_EQUAL_TO = ">=";
export const LESS_THAN_OR_EQUAL_TO = "<=";
export const WEEK_NUMBER = "weekNumber";
export const IS_NO_EMAIL = "isNoEmail";
export const EmailDomain = "@ironmountain.com";
export const ITContractor = "IT Contractor";
export const JOB_TYPE= "jobType";
